export default {
    BODY_SHAPE_1: ["ทรงกล้วย (ทรงตรง ตัวบาง)", "Banana Shape"],
    BODY_SHAPE_2: ["ทรงนาฬิกาทราย (อก เอว สะโพก)", "Hourglasss Shape"],
    BODY_SHAPE_3: ["สะโพกแน่น ช่วงบนเบา", "Pear Shape"],
    BODY_SHAPE_4: ["ทรงแอปเปิ้ล (อกผายไหล่ผึ่ง)", "Apple Shape"],
    BODY_SHAPE_5: ["ทรงแตงโม (เจ้าเนื้อ)", "Watermelon Shape"],
    BODY_TONE_1: ["ผิวขาวซีด", "White"],
    BODY_TONE_2: ["ผิวขาวอมชมพู", "Pinky Fair"],
    BODY_TONE_3: ["ผิวขาวเหลือง", "Yellow Fair"],
    BODY_TONE_4: ["ผิวสองสี", "2 Tones"],
    BODY_TONE_5: ["ผิวแทน ผิวสีน้ำผึ้ง", "Copper"],
    BODY_TONE_6: ["ผิวคล้ำ", "Dark"],
    BODY_TYPE_1: ["ผิวแห้ง", "Dry"],
    BODY_TYPE_2: ["ผิวมัน", "Oily"],
    BODY_TYPE_3: ["ผิวธรรมดา", "Normal"],
    BODY_PROBLEM_1: ["ผิวแพ้ง่าย", "Sensitive"],
    BODY_PROBLEM_2: ["ริ้วรอย", "Wrinkles"],
    BODY_PROBLEM_3: ["จุดด่างดำ", "Black Spots"],
    BODY_PROBLEM_4: ["ฝ้า - กระ", "Freckles"],
    BODY_PROBLEM_5: ["ผิวแตกลาย", "Stretch Marks"],
    FACE_SHAPE_1: ["รูปกลม", "Round"],
    FACE_SHAPE_2: ["รูปยาว", "Oblong"],
    FACE_SHAPE_3: ["รูปเพชร", "Diamond"],
    FACE_SHAPE_4: ["รูปไข่", "Oval"],
    FACE_SHAPE_5: ["รูปหัวใจ", "Heart"],
    FACE_SHAPE_6: ["รูปสี่เหลี่ยม", "Square"],
    FACE_TONE_1: ["ผิวขาวอมชมพู", "Pinky Fair"],
    FACE_TONE_2: ["ผิวขาวเหลือง", "Yellow Fair"],
    FACE_TONE_3: ["ผิวสองสี", "2 Tones"],
    FACE_TONE_4: ["ผิวแทน ผิวสีน้ำผึ้ง", "Copper"],
    FACE_TONE_5: ["ผิวคล้ำ", "Dark"],
    FACE_TYPE_1: ["ผิวแห้ง", "Dry"],
    FACE_TYPE_2: ["ผิวมัน", "Oily"],
    FACE_TYPE_3: ["ผิวผสม", "Mixed"],
    FACE_TYPE_4: ["ผิวธรรมดา", "Normal"],
    FACE_PROBLEM_1: ["ผิวแพ้ง่าย", "Sensitive"],
    FACE_PROBLEM_2: ["สิว", "Acne"],
    FACE_PROBLEM_3: ["รูขุมขนกว้าง", "Big Pores"],
    FACE_PROBLEM_4: ["ริ้วรอย", "Wrinkles"],
    FACE_PROBLEM_5: ["จุดด่างดำ", "Black Spots"],
    FACE_PROBLEM_6: ["ฝ้า - กระ", "Freckles"],
    HAIR_TYPE_1: ["ผมเส้นเล็ก", "Thin"],
    HAIR_TYPE_2: ["ผมเส้นใหญ่", "Thick"],
    HAIR_TYPE_3: ["ผมตรง", "Straight"],
    HAIR_TYPE_4: ["ผมหยักศก", "Curl"],
    HAIR_TYPE_5: ["ผมทำเคมี", "Chemical Used (type changing)"],
    HAIR_PROBLEM_1: ["หนังศีรษะมัน", "Oily Head"],
    HAIR_PROBLEM_2: ["รังแค", "Dandruff"],
    HAIR_PROBLEM_3: ["ผมแตกปลาย", "Split Ends"],
    HAIR_PROBLEM_4: ["ผมจัดทรงยาก", "Hard to style"],
    HAIR_PROBLEM_5: ["ผมร่วง", "Hair Loss"],
    HAIR_PROBLEM_6: ["ผมขาดง่าย", "Weakly Hair"],
    HAIR_PROBLEM_7: ["ผมแห้งเสีย", "Dry"],
}